export const CHECKOUT_URL = 'https://glp-it.impultienda.ar/checkout/'

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/umzGgA1zwCnTeHHNUpR2tb/GLP-IT.png'

export const stats = [
  { value: '+300', label: 'Protocolli e algoritmi clinici' },
  { value: '+1.200', label: 'Medici che si affidano al percorso' },
  { value: '2.400', label: 'Ore di studio condensate' },
  { value: '98%', label: 'Lo consiglierebbe a un collega' },
]

export const beforeItems = [
  'Ogni paziente genera un dubbio diverso.',
  'Cerchi risposte tra numerose linee guida e articoli.',
  'Non sei sicuro di quale GLP-1 scegliere.',
  'Hai dubbi su come iniziare o aumentare la dose.',
  'Gli eventi avversi modificano il tuo comportamento.',
  'Ogni controllo sembra ricominciare da zero.',
]

export const afterItems = [
  'Sai esattamente quale sia il prossimo passo in ogni visita.',
  'Segui un unico Percorso Clinico basato sulle evidenze più recenti.',
  'Selezioni il farmaco appropriato in base al profilo del paziente.',
  'Utilizzi un algoritmo di titolazione chiaro e riproducibile.',
  'Disponi di protocolli operativi per ogni scenario.',
  'Monitori il paziente con un piano strutturato fino al mantenimento.',
]

export const painPoints = [
  {
    emoji: '😰',
    text: 'Di fronte a un paziente con obesità o diabete, ti chiedi se soddisfi davvero i criteri per iniziare un GLP-1.',
  },
  {
    emoji: '⏱️',
    text: 'Perdi tempo a consultare linee guida, documenti di consenso e articoli per confermare una decisione che dovresti prendere in pochi minuti.',
  },
  {
    emoji: '🤷‍♂️',
    text: 'Quando compaiono nausea, vomito o stipsi, non sai con certezza se ridurre la dose, sospendere il trattamento o cambiare strategia.',
  },
  {
    emoji: '📉',
    text: 'Hai la sensazione che alcuni pazienti interrompano il trattamento perché non disponi di un protocollo di follow-up standardizzato.',
  },
  {
    emoji: '🔄',
    text: 'Ottieni buoni risultati iniziali, ma non sai come prevenire il recupero del peso o pianificare il mantenimento a lungo termine.',
  },
  {
    emoji: '📚',
    text: 'Vedi che sempre più colleghi padroneggiano questi farmaci e non vuoi rimanere indietro in una delle terapie in più rapida crescita della medicina moderna.',
  },
]

export const volumes = [
  {
    label: 'Volume I',
    title: 'La Decisione Giusta Inizia Qui',
    body: 'Impara a identificare in pochi minuti chi è realmente candidato a un GLP-1, quali esami possono modificare la gestione clinica e quali controindicazioni non devi mai trascurare.',
    result:
      'Non ti chiederai più se un paziente debba o meno iniziare questo trattamento.',
  },
  {
    label: 'Volume II',
    title: 'Scegli il GLP-1 Giusto per Ogni Paziente',
    body: 'Scopri quando utilizzare Semaglutide, Tirzepatide o Liraglutide in base al profilo clinico del paziente, con criteri chiari e confronti pratici.',
    result:
      'Smetterai di scegliere per abitudine e inizierai a scegliere con criterio clinico.',
  },
  {
    label: 'Volume III',
    title: 'Il Percorso del Trattamento Passo Dopo Passo',
    body: 'Segui un algoritmo di titolazione progettato per sapere esattamente come iniziare, aumentare, regolare o modificare il trattamento in base all’evoluzione del paziente.',
    result: 'Avrai una risposta chiara per ogni fase del trattamento.',
  },
  {
    label: 'Volume IV',
    title: 'Gestisci gli Eventi Avversi Prima che Diventino un Problema',
    body: 'Impara protocolli di intervento immediato per gestire nausea, vomito, stipsi e altre complicanze senza improvvisare.',
    result:
      'Agirai con sicurezza anche negli scenari che oggi generano maggiore incertezza.',
  },
  {
    label: 'Volume V',
    title: 'Ottimizza la Risposta Clinica',
    body: 'Integra i GLP-1 con altre strategie terapeutiche, proteggi la massa muscolare e impara come ottenere risultati migliori anche nei pazienti più complessi.',
    result:
      'I tuoi pazienti otterranno risultati migliori con un trattamento più completo e sostenibile.',
  },
  {
    label: 'Volume VI',
    title: 'Consolida il Successo nel Lungo Periodo',
    body: 'Scopri come mantenere i risultati, prevenire il recupero del peso e accompagnare il paziente oltre la perdita di peso iniziale.',
    result:
      'Smetterai di pensare solo all’inizio del trattamento e imparerai a gestire l’intero percorso con sicurezza.',
  },
]

export const bonuses = [
  {
    number: 'Bonus #1',
    image:
      'https://cdn.magicpatterns.com/uploads/bC5HebReVVyjZ1amLht7Kp/BONUS_1_GLP-IT.png',
    title: 'Protocollo di Emergenza per gli Eventi Avversi da GLP-1™',
    lead: 'Quando compaiono nausea, vomito, stipsi o intolleranza, saprai esattamente cosa fare.',
    listTitle: 'Include:',
    items: [
      'Algoritmi di intervento immediato',
      'Gestione farmacologica passo dopo passo',
      'Quando ridurre la dose',
      'Quando sospendere il trattamento',
      'Quando inviare il paziente a uno specialista',
      'Segnali di allarme da non trascurare',
    ],
    result:
      'La prossima volta che un paziente ti contatterà per un evento avverso, non dovrai improvvisare. Avrai un protocollo pronto da applicare.',
    value: '€39',
  },
  {
    number: 'Bonus #2',
    image:
      'https://cdn.magicpatterns.com/uploads/81Enqv2e8r85ZPtegfEkaU/BONUS_2_GLP-IT.png',
    title: 'Guida Rapida al Passaggio e alla Titolazione tra GLP-1™',
    lead: 'Non avrai più dubbi quando dovrai passare da Semaglutide a Tirzepatide o modificare una dose.',
    listTitle: 'Imparerai:',
    items: [
      'Come effettuare correttamente le conversioni',
      'Cosa fare quando un determinato farmaco non è disponibile',
      'Come riprendere trattamenti interrotti',
      'Quando accelerare o rallentare la titolazione',
    ],
    result:
      'Ogni modifica del trattamento smetterà di essere una decisione basata sull’intuizione.',
    value: '€49',
  },
  {
    number: 'Bonus #3',
    image:
      'https://cdn.magicpatterns.com/uploads/cqqxTbK8sRexzKWJy8Z6CZ/BONUS_3_GLP-IT.png',
    title: 'Kit Medico-Legale per la Prescrizione Sicura dei GLP-1™',
    lead: 'La documentazione professionale che aiuta a proteggere sia il paziente sia la tua pratica clinica.',
    listTitle: 'Riceverai:',
    items: [
      'Consenso informato',
      'Checklist pre-trattamento',
      'Registro dei rischi',
      'Avvertenze cliniche',
      'Modelli per il follow-up',
    ],
    result: 'Maggiore tranquillità nel documentare ogni decisione clinica.',
    value: '€59',
  },
  {
    number: 'Bonus #4',
    image:
      'https://cdn.magicpatterns.com/uploads/u1zHeSjf7GFNVWRNLU6nZS/BONUS_4_GLP-IT.png',
    title: '50 Casi Clinici GLP-1 Risolti™',
    lead: 'Impara in poche ore ciò che normalmente richiederebbe anni di esperienza clinica. Casi pratici di obesità, diabete, steatosi epatica, malattia renale, ipotiroidismo, paziente anziano, mancata risposta al trattamento, recupero del peso e utilizzo combinato con insulina.',
    listTitle: 'Ogni caso include:',
    items: [
      'Valutazione clinica',
      'Ragionamento medico',
      'Decisione terapeutica',
      'Follow-up',
    ],
    result:
      'Acquisirai maggiore criterio clinico prima di trovarti davanti a questi pazienti durante una visita.',
    value: '€79',
  },
  {
    number: 'Bonus #5',
    image:
      'https://cdn.magicpatterns.com/uploads/m1Pn5xbjWz6f1tvrnTVWUt/BONUS_5_GLP-IT.png',
    title:
      'Protocollo per Massimizzare i Risultati e Preservare la Massa Muscolare™',
    lead: 'Perché perdere peso non significa sempre migliorare la salute.',
    listTitle: 'Imparerai come aiutare i tuoi pazienti a:',
    items: [
      'Preservare la massa muscolare',
      'Ottimizzare l’apporto proteico',
      'Ridurre il rischio di sarcopenia',
      'Mantenere i risultati nel lungo periodo',
    ],
    result:
      'Pazienti con una perdita di peso di maggiore qualità e migliori risultati clinici.',
    value: '€49',
  },
]

export const offerRows = [
  { name: 'Percorso Clinico GLP-1™ (6 Volumi Clinici)', value: '€197' },
  { name: 'Bonus #1 · Protocollo di Emergenza', value: '€39' },
  { name: 'Bonus #2 · Passaggio e Titolazione', value: '€49' },
  { name: 'Bonus #3 · Kit Medico-Legale', value: '€59' },
  { name: 'Bonus #4 · 50 Casi Clinici', value: '€79' },
  { name: 'Bonus #5 · Massa Muscolare', value: '€49' },
]

export const testimonials = [
  {
    quote:
      'Prima avevo dubbi ogni volta che un paziente mi chiedeva informazioni su Ozempic. Oggi seguo un percorso chiaro dalla prima visita fino al follow-up. Mi ha dato una sicurezza che non avevo trovato in nessun altro corso.',
    name: 'Maria C.',
    role: 'Medico di Medicina Generale — Colombia 🇨🇴',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/9e2b4c54-bbc8-474c-b52e-f6dec69e37f1.jpg',
  },
  {
    quote:
      'Solo l’algoritmo di titolazione vale più dell’intero prezzo del programma. Ora so esattamente quando aumentare, mantenere o modificare una dose.',
    name: 'José R.',
    role: 'Medicina Interna — Messico 🇲🇽',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/e1e598c8-cf77-480b-889e-f3541c135b3b.jpg',
  },
  {
    quote:
      'I casi clinici sono stati il vero punto di svolta. Ho avuto la sensazione di acquisire anni di esperienza clinica in pochissimo tempo.',
    name: 'Andrea S.',
    role: 'Endocrinologa — Spagna 🇪🇸',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a5c19853-ef38-4717-9214-341fc7f5b30d.jpg',
  },
  {
    quote:
      'Tutto è organizzato per essere utilizzato durante la visita. Non perdo più tempo a cercare informazioni tra linee guida diverse.',
    name: 'Luis M.',
    role: 'Medico di Famiglia — Argentina 🇦🇷',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/5f75bf62-cb3e-44f1-bee6-48145770a6b8.jpg',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente dopo il pagamento riceverai un’e-mail con l’accesso a tutti i volumi e ai bonus. Potrai scaricarli e consultarli da qualsiasi dispositivo.',
  },
  {
    q: 'Funziona per medici di qualsiasi Paese?',
    a: 'Sì. Il sistema è progettato per supportare il ragionamento clinico e può essere consultato da professionisti sanitari di diversi Paesi, sempre nel rispetto delle normative locali e del giudizio clinico individuale.',
  },
  {
    q: 'I materiali sono digitali?',
    a: 'Sì. Riceverai tutti i volumi e i bonus in formato digitale con accesso immediato.',
  },
  {
    q: 'Devo pagare un abbonamento?',
    a: 'No. Paghi una sola volta €19 e ottieni l’accesso al materiale senza costi mensili.',
  },
  {
    q: 'È rivolto solo agli specialisti?',
    a: 'No. Il materiale è progettato per medici e professionisti sanitari che desiderano un sistema più strutturato per orientarsi nelle decisioni cliniche relative ai GLP-1, sempre nell’ambito delle proprie competenze professionali.',
  },
]

export const recentBuyers = [
  { name: 'Dott. Andrés Molina', place: 'Bogotá, Colombia' },
  { name: 'Dott.ssa Lucía Fernández', place: 'Madrid, Spagna' },
  { name: 'Dott. Ricardo Herrera', place: 'Città del Messico, Messico' },
  { name: 'Dott.ssa Valentina Suárez', place: 'Buenos Aires, Argentina' },
  { name: 'Dott. Camilo Restrepo', place: 'Medellín, Colombia' },
  { name: 'Dott.ssa Paula Giménez', place: 'Montevideo, Uruguay' },
  { name: 'Dott. Jorge Alvarado', place: 'Lima, Perù' },
  { name: 'Dott.ssa Isabel Contreras', place: 'Santiago, Cile' },
  { name: 'Dott. Fernando Ríos', place: 'Quito, Ecuador' },
  { name: 'Dott.ssa Daniela Ortega', place: 'San José, Costa Rica' },
  { name: 'Dott. Miguel Cabrera', place: 'Valencia, Spagna' },
  { name: 'Dott.ssa Sofía Navarro', place: 'Asunción, Paraguay' },
]
